import React from 'react';

const SVGComponent = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={props.width || '20'}
      height={props.height || '20'}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <ellipse
        cx="10.0002"
        cy="9.79412"
        rx="5.29412"
        ry="5.29412"
        fill={props.color || 'white'}
        fillOpacity="0.25"
      />
    </svg>
  );
};

export const CircleEmptyIcon = React.memo(SVGComponent);
